import type { PhotoUploadPhase } from './types'

/** Слова этапа загрузки — по реальному состоянию, а не по ожиданию. */
export const UPLOAD_STAGES: Readonly<Record<PhotoUploadPhase, string>> = {
  preparing: 'Готовлю снимок',
  sending: 'Отправляю на сервер',
  waiting: 'Жду ответ сервера',
  review: 'Проверьте обрезку',
  failed: 'Не загружено',
}
